import Vue from "vue";
import VueResource from "vue-resource";
import firebase from "firebase";
import axios from "axios";
import Vuex from 'vuex'
import Meta from "vue-meta";
import VueTheMask from "vue-the-mask";
import i18n from "@/plugins/i18n";
import { store } from './store/store'
import router from "./router";
import App from "./App.vue";
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueTheMask);
Vue.use(Vuex);
Vue.use(Meta);
Vue.use(VueResource);
Vue.use(VueSimpleAlert);

const config = {
	apiKey: process.env.VUE_APP_API_KEY,
	authDomain: process.env.VUE_APP_AUTH_DOMAIN,
	databaseURL: process.env.VUE_APP_DATABASE_URL,
	projectId: process.env.VUE_APP_PROJECT_ID,
	storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID
};
firebase.initializeApp(config);

Vue.config.productionTip = false;
let app = "";

const Bus = new Vue();
export default Bus;

firebase.auth().onAuthStateChanged(() => {
	if (!app) {
		app = new Vue({
			router,
			store,
			i18n,
			render: h => h(App)
		}).$mount("#app");
	}
});
